<template>
  <div class="ad-container">
    <el-card class="ad-card" shadow="hover">
      <div class="ad-header">
        <i class="el-icon-s-opportunity"></i>
        <span>精选推荐</span>
        <el-tag type="danger" size="mini">Sponsored</el-tag>
      </div>

      <div class="carousel-wrapper">
        <el-carousel
          ref="carousel"
          :interval="5000"
          arrow="hover"
          height="280px"
          :autoplay="false"
          indicator-position="none"
          @change="handleCarouselChange"
        >
          <el-carousel-item v-for="(ad, index) in adList" :key="index">
            <a :href="ad.link" target="_blank" rel="noopener" class="ad-link">
              <el-image
                :src="ad.image"
                :alt="ad.title"
                class="ad-image"
                fit="cover"
              >
                <div slot="placeholder" class="image-slot">
                  <i class="el-icon-loading"></i>
                </div>
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div class="ad-content">
                <h3 class="ad-title">{{ ad.title }}</h3>
                <p class="ad-desc">{{ ad.description }}</p>
              </div>
            </a>
          </el-carousel-item>
        </el-carousel>

        <div class="custom-indicators">
          <div
            v-for="(item, index) in adList"
            :key="index"
            class="indicator-dot"
            :class="{ active: currentIndex === index }"
            @click="handleDotClick(index)"
          ></div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "Advertisement",
  data() {
    return {
      currentIndex: 0,
      adList: [
        {
          id: 1,
          title: "宠物智能喂食器",
          description: "远程控制/定时投喂/智能称重",
          image:
            "http://gips3.baidu.com/it/u=3886271102,3123389489&fm=3028&app=3028&f=JPEG&fmt=auto?w=1280&h=960",
          link: "https://example.com",
        },
        {
          id: 2,
          title: "宠物美容护理套装",
          description: "专业工具组合8件套限时特惠",
          image:
            "http://gips2.baidu.com/it/u=195724436,3554684702&fm=3028&app=3028&f=JPEG&fmt=auto?w=1280&h=960",
          link: "https://example.com",
        },
        {
          id: 3,
          title: "宠物定位追踪器",
          description: "GPS实时定位/电子围栏/防水设计",
          image:
            "https://gips3.baidu.com/it/u=1039279337,1441343044&fm=3028&app=3028&f=JPEG&fmt=auto&q=100&size=f1024_1024",
          link: "https://example.com",
        },
      ],
    };
  },
  methods: {
    handleDotClick(index) {
      this.currentIndex = index;
      this.$refs.carousel.setActiveItem(index);
    },
    handleCarouselChange(index) {
      this.currentIndex = index;
    },
  },
};
</script>

<style scoped>
.ad-container {
  height: 100%;
}

.ad-card {
  height: 100%;
  background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(64, 158, 255, 0.1);
  position: relative;
}

.ad-card >>> .el-card__body {
  padding: 0;
  height: calc(100% - 50px); /* 减去头部高度 */
}

.ad-header {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  background: linear-gradient(90deg, rgba(64, 158, 255, 0.1), transparent);
  border-bottom: 1px dashed #ebeef5;
  height: 50px;
}

.ad-header i {
  color: #e6a23c;
  margin-right: 10px;
  font-size: 18px;
}

.ad-header span {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  flex: 1;
}

.el-tag {
  margin-left: 10px;
  transform: scale(0.9);
}

.carousel-wrapper {
  position: relative;
  height: 100%;
}

.ad-link {
  display: block;
  height: 100%;
  text-decoration: none;
  color: inherit;
}

.ad-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s;
}

.ad-item:hover .ad-image {
  transform: scale(1.03);
}

.ad-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  color: white;
  z-index: 1;
}

.ad-title {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 8px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.ad-desc {
  font-size: 14px;
  margin: 0;
  opacity: 0.9;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.custom-indicators {
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 10;
}

.indicator-dot {
  width: 8px;
  height: 8px;
  margin: 0 5px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s;
}

.indicator-dot.active {
  width: 20px;
  border-radius: 5px;
  background-color: #fff;
}

.indicator-dot:hover {
  background-color: rgba(255, 255, 255, 0.8);
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 24px;
}

@media (max-width: 768px) {
  .ad-title {
    font-size: 16px;
  }

  .ad-desc {
    font-size: 12px;
  }

  .ad-header {
    padding: 10px 15px;
  }
}
</style>
